import { pillars } from "../../../mocks/guaData";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

export default function AnalysisPillars() {
  return (
    <section id="analysis" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHead
          align="center"
          eyebrow="四大拆解视角"
          title="从四个维度，把一场吃瓜事件看透"
          desc="事件营销、幕后推手、舆论引导、真相核查——这是我们研究每一则热点时的固定视角。"
        />
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {pillars.map((p, i) => (
            <Reveal key={p.tag} delay={i * 90}>
              <a
                href="#deep"
                className="group flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-200 hover:bg-primary-50/40"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${p.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <span className="mt-5 text-xs font-bold uppercase tracking-wider text-accent-600">{p.tag}</span>
                <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
                <span className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-primary-600">
                  去看对应解析
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}